import { v4 as uuidv4 } from 'uuid';
import thumb1 from '../../assets/images/testimonial-img.png';

const testimonialData = [
  {
    id: uuidv4(),
    heading:
      "I'd like to note the high professionalism, the efficiency and the pleasant cost of work.",
    desc: 'I would like to thank your company for the quality impeccable work. I would like to note the high professionalism of the staff, the efficiency and the pleasant cost of work. I would like to thank your company for the quality and impeccable work.',
    clientName: 'Benjamin Foster',
    clientRole: 'Minneapolis',
    thumb: thumb1,
  },

  {
    id: uuidv4(),
    heading:
      "I'd like to note the high professionalism, the efficiency and the pleasant cost of work.",
    desc: 'I would like to thank your company for the quality impeccable work. I would like to note the high professionalism of the staff, the efficiency and the pleasant cost of work. I would like to thank your company for the quality and impeccable work.',
    clientName: 'Benjamin Foster',
    clientRole: 'Minneapolis',
    thumb: thumb1,
  },

  {
    id: uuidv4(),
    heading:
      "I'd like to note the high professionalism, the efficiency and the pleasant cost of work.",
    desc: 'I would like to thank your company for the quality impeccable work. I would like to note the high professionalism of the staff, the efficiency and the pleasant cost of work. I would like to thank your company for the quality and impeccable work.',
    clientName: 'Benjamin Foster',
    clientRole: 'Minneapolis',
    thumb: thumb1,
  },
];

export default testimonialData;
